import EventEmitter from 'eventemitter3'
import AssetsManager from '../data/AssetsManager'
import DataManager from '../data/DataManager'

/**
 * RankingManagerクラス
 */
class RankingManager extends EventEmitter{
  // ---------------------------------------------------------------------------------------------------------
  // --	RankingManager
  // ---------------------------------------------------------------------------------------------------------

  /**
   * コンストラクタ
   */
  constructor() {
    super();
  }

  // ----------------------------------------------------------------------------------------------------------------
  // --	初期化
  // ----------------------------------------------------------------------------------------------------------------

  init()
  {
    //コンフィグ取得
    this.config = AssetsManager.getConfig();

    //モバイルバックエンド初期化
    this.ncmb = new NCMB(DataManager.getData('APPLICATION_KEY'), DataManager.getData('CLIENT_KEY'));
  }


  // ----------------------------------------------------------------------------------------------------------------
  // --	スコア送信
  // ----------------------------------------------------------------------------------------------------------------

  sendScore(username, score)
  {
    // スコア（Score）クラスの生成
    const Score = this.ncmb.DataStore("ScoreClass");
    
    //名前のチェック
    if (username === null || username === "")
    {
      username = prompt("ユーザ名を指定してください");
    }
  
    // スコアのインスタンスを生成
    const scoreData = new Score({
      score: score,
      username: username
    });
  
    // 送信処理実行
    scoreData.save()
    .then((saved) =>
    {
      this.emit("send-success");
    })
    .catch((err) => 
    {
      this.emit("send-error");
    });
  }

  sendScoreByObj(obj)
  {
    // スコア（Score）クラスの生成
    const Score = this.ncmb.DataStore("ScoreClass");
    
    //名前のチェック
    if (obj.username === null || obj.username === "")
    {
      obj.username = prompt("ユーザ名を指定してください");
    }
  
    // スコアのインスタンスを生成
    const scoreData = new Score(obj);
  
    // 送信処理実行
    scoreData.save()
    .then((saved) =>
    {
      this.emit("send-success");
    })
    .catch((err) =>
    {
      this.emit("send-error");
    });
  }


  // ----------------------------------------------------------------------------------------------------------------
  // --	ランキングデータ取得
  // ----------------------------------------------------------------------------------------------------------------

  getRanking()
  {
    //スコア情報を取得するため、クラスを作成
    const Score = this.ncmb.DataStore("ScoreClass");
  
    //スコアを降順に10件取得
    Score.order("score", true)
    .limit(100)
    .fetchAll()
    .then((results) =>
    {
      this.emit("success", results);
    })
    .catch((err) =>
    {
      this.emit("error", err);
    });
  }
	    
  // ---------------------------------------------------------------------------------------------------------
}

export default new RankingManager()
